import { Actions, createNamespace } from "../../../flux/Actions";

const ns = createNamespace('ERROR');
export const names = {
    SET_ERROR: ns('SET_ERROR'),
    CLEAR_ERROR: ns('CLEAR_ERROR'),
};

// Flux actions to manipulate ErrorStore's state
export class ErrorActions extends Actions
{
    setError = (err: Error, dispatchToken: string, msTimeout?: number) => {
        this.dispatchErr(names.SET_ERROR, err, dispatchToken);

        // We can suppress error message after specifier timeout
        if(typeof msTimeout === 'number')
            setTimeout(() => this.clearError(dispatchToken), msTimeout);
    }
    
    clearError = (dispathcToken: string) => this.dispatch(names.CLEAR_ERROR, null, dispathcToken);
}


// WEBPACK FOOTER //
// ./src/app/flux/Error/ErrorActions.ts